module.exports = __webpack_public_path__ + "static/media/w-icon.65ead22f.svg";